'use client';

import dynamic from 'next/dynamic';
import React from 'react';
import { ContentType } from '@jlg-website/shared/constants';

export const loading = () => <>Loading...</>;

const AboutUsForm = dynamic(
  () => import('@/components/admin/contents/content-types/about-us-form'),
  { loading }
);
const ArticleForm = dynamic(
  () => import('@/components/admin/contents/content-types/article-form'),
  { loading }
);
const CaseResultForm = dynamic(
  () => import('@/components/admin/contents/content-types/case-result-form'),
  { loading }
);
const FaqForm = dynamic(() => import('@/components/admin/faq/faq-form'), { loading });
const InjuryForm = dynamic(() => import('@/components/admin/contents/content-types/injury-form'), {
  loading,
});
const PracticeAreasForm = dynamic(
  () => import('@/components/admin/contents/content-types/practice-areas-form'),
  { loading }
);
const ProcessStepsForm = dynamic(
  () => import('@/components/admin/contents/content-types/process-steps-form'),
  { loading }
);
const ReasonsToChooseUsForm = dynamic(
  () => import('@/components/admin/contents/content-types/reasons-to-choose-us-form'),
  { loading }
);
const RecoveryExpertiseForm = dynamic(
  () => import('@/components/admin/contents/content-types/recovery-expertise-form'),
  { loading }
);
const ThingsToKnowAboutForm = dynamic(
  () => import('@/components/admin/contents/content-types/things-to-know-about-form'),
  { loading }
);
const WaysToHelpForm = dynamic(
  () => import('@/components/admin/contents/content-types/ways-to-help-form'),
  { loading }
);
const AccidentTypesForm = dynamic(
  () => import('@/components/admin/contents/content-types/accident-types-form'),
  { loading }
);
const InjuryTypeForm = dynamic(
  () => import('@/components/admin/contents/content-types/injury-types-form'),
  { loading }
);
const FooterContentForm = dynamic(
  () => import('@/components/admin/contents/content-types/footer-content-form'),
  { loading }
);
const FounderForm = dynamic(
  () => import('@/components/admin/contents/content-types/founder-form'),
  { loading }
);

export const formComponents: Record<
  (typeof ContentType)[keyof typeof ContentType],
  React.ComponentType<any>
> = {
  [ContentType.AboutUs]: AboutUsForm,
  [ContentType.Article]: ArticleForm,
  [ContentType.FAQ]: FaqForm,
  [ContentType.CaseResults]: CaseResultForm,
  [ContentType.AccidentTypes]: AccidentTypesForm,
  [ContentType.Injury]: InjuryForm,
  [ContentType.InjuryTypes]: InjuryTypeForm,
  [ContentType.PracticeAreas]: PracticeAreasForm,
  [ContentType.ProcessSteps]: ProcessStepsForm,
  [ContentType.ReasonsToChooseUs]: ReasonsToChooseUsForm,
  [ContentType.RecoveryExpertise]: RecoveryExpertiseForm,
  [ContentType.ThingsToKnowAbout]: ThingsToKnowAboutForm,
  [ContentType.WaysToHelp]: WaysToHelpForm,
  [ContentType.FooterContent]: FooterContentForm,
  [ContentType.Founder]: FounderForm,
};
